import { render, staticRenderFns } from "./UserLoginCodeAdd.vue?vue&type=template&id=72d4a1e0&"
import script from "./UserLoginCodeAdd.vue?vue&type=script&lang=js&"
export * from "./UserLoginCodeAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports